@use 'sass:map';
@use 'common/assets/scss/global' as *;

ul {
  @include unstyled-list;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  grid-auto-rows: 1fr;
  gap: 15px;
  text-align: center;
  font-size: var(--#{$prefix}font-size-xxs);
  font-weight: 500;
  letter-spacing: -0.25px;

  > li > a {
    @include unstyled-link;
    border: 1px solid var(--#{$prefix}stroke);
    border-radius: 10px;
    box-shadow: var(--#{$prefix}shadow-neutral) HEXToRGBA($black, 0.1);
    padding: 12px;
    display: inline-block;
    width: 100%;
    height: 100%;
    outline-color: transparent;
    outline-offset: -1px;
    transition:
      outline 0.15s ease-in,
      box-shadow 0.15s ease-in;

    > svg {
      display: block;
      margin: 0 auto 8px auto;
      height: 64px;
      width: 64px;
      color: HEXToRGBA(var(--#{$prefix}basic-black), 0.33);
      transition: color 0.15s ease-in;

      @media (hover: none) or (pointer: coarse) {
        color: var(--#{$prefix}primary);
      }
    }

    > span {
      white-space: pre-line;
    }

    &:hover,
    &:focus-visible {
      outline: 2px solid var(--#{$prefix}primary);
      box-shadow: var(--#{$prefix}shadow-hover) HEXToRGBA(var(--#{$prefix}primary), 0.2);

      > svg {
        color: var(--#{$prefix}primary);
      }
    }
  }

  @media (width >= map.get($grid-breakpoints, sm)) {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    font-size: unset;
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    > li > a {
      padding: 16px;
    }
  }
}
